import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import * as Highcharts from 'highcharts/highstock';
import HC_exporting from 'highcharts/modules/exporting';
import HC_exporting_data from 'highcharts/modules/export-data';
import HC_xrange from 'highcharts/modules/xrange';
import { TankLog } from '../tank-log';
import { I18NService } from '../../../shared/i18n/i18n.service';

HC_exporting(Highcharts);
HC_exporting_data(Highcharts);
HC_xrange(Highcharts);

@Component({
  selector: 'app-chart-historic',
  templateUrl: './chart-historic.component.html',
  styleUrls: ['./chart-historic.component.css']
})
export class ChartHistoricComponent {

  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  chartOptions: Highcharts.Options = {  };
  chart: Highcharts.Chart;
  chartCallback: Highcharts.ChartCallbackFunction;
  @ViewChild('chart', { static: true }) chartElement: ElementRef;

  @Input()
  currentTank: TankLog;

  constructor(private i18nService: I18NService) {
    var self = this;
    this.chartCallback = chart => { self.chart = chart; };
  }

  @Input()
  set tankSeries(tankSeries: TankLog[]){
    this.updateValues(tankSeries);
  }

  private updateValues(tankSeries: TankLog[]) {
    this.chartConstructor = "stockChart";
    this.chartOptions = this.getLineChartConfig(tankSeries);
  }

  private getLineChartConfig(tankSeries : TankLog[]): Highcharts.Options {
    let chartOptions = this.getBaseChartConfig();
    chartOptions.chart.type = "line";
    chartOptions.series = this.parserLineSeries(tankSeries);

    return chartOptions;
  }

  private getBaseChartConfig():Highcharts.Options {
    var self = this;
    return {
      chart: {
        zoomType: 'x',
      },
      colors: ["#AF2A0A", "#0d3f85", "#15AF27", "#feb90c", "#96bd1e", "#634d38", "#0080cd", "#025c37", "#ef9027", "#04afa0"],
      tooltip: {
        valueDecimals: 2,
        shared: true,
        crosshairs: true,
        split: false,
        xDateFormat: '%H:%M:%S %e/%m'
      },
      rangeSelector: {
        buttons: [
          {
            type: 'hour',
            count: 12,
            text: '12h'
          },
          {
            type: 'day',
            count: 1,
            text: '1d'
          },
          {
            type: 'day',
            count: 7,
            text: '7d'
          },
          {
            type: 'month',
            count: 1,
            text: '1m'
          },
          {
            type: 'all',
            text: 'Todo'
          },
        ],
        inputEnabled: false,
        selected: 1
      },
      plotOptions: {
        series: {
          stickyTracking: false,
          events: {
            mouseOut: function() {
              this.chart.tooltip.hide();
            }
          }
        }
      },
      exporting: {
        menuItemDefinitions: {
          downloadPNG: {
            onclick: function() {
              var c = document.createElement('canvas');

              let element = self.chartElement["el"].nativeElement;
              c.width = element.clientWidth;
              c.height = element.clientHeight;
              var ctx = c.getContext('2d');

              var svgURL = new XMLSerializer().serializeToString(element.querySelector("svg"));
              var img = new Image();
              img.onload = function() {
                let self2: any = this;
                ctx.drawImage(self2, 0, 0);
                var link = document.createElement('a');
                link.setAttribute('download', self.currentTank.name + new Date().toLocaleString() + '.png');
                link.setAttribute('href', c.toDataURL("image/png").replace("image/png", "image/octet-stream"));
                link.click();
              };
              img.src = 'data:image/svg+xml; charset=utf8, ' + encodeURIComponent(svgURL);
            },
            text: 'Download PNG'
          }
        },
        filename: self.currentTank.name + new Date().toLocaleString(),
        buttons: {
          contextButton: {
            menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "separator", "downloadCSV", "downloadXLS"]
          }
        }
      },
      yAxis: [{
        max: 40,
        min: 8,
        tickAmount: 8,
        gridLineWidth: 0,
        title: {
          text: this.i18nService.get("temperature") + ' (°C)'
        },
        resize: {
          enabled: true
        },
        labels: {
          align: 'right',
          reserveSpace: true
        },
        opposite: true
      }, {
        gridLineWidth: 0,
        title: {
          text: this.i18nService.get('volume') + ' (L)'
        },
        labels: {
          formatter: function () {
            return this.value + '';
          }
        },
        resize: {
          enabled: true
        },
        opposite: false
      }, {
        gridLineWidth: 0,
        title: {
          text: this.i18nService.get("water") + ' (mm)'
        },
        resize: {
          enabled: true
        },
        labels: {
          format: '{value:.2f}',
          align: 'right',
          reserveSpace: true
        },
        opposite: true
      }],
      credits: {
        enabled: false
      },
      legend: {
        enabled: true
      }
    } as Highcharts.Options;
  }

  private parserLineSeries(tankSeries : TankLog[]): any[]{
    let series = [];

      let tempSerie = {
        name: this.i18nService.get("temperature") + ' (°C)',
        data: [],
        tooltip: {
          valueSuffix: ' º',
          xDateFormat: '%H:%M:%S %e/%m'
        }
      }
      let waterSerie = {
        name: this.i18nService.get('water') + ' (mm)',
        data: [],
        yAxis: 2,
        tooltip: {
          valueSuffix: ' mm',
          xDateFormat: '%H:%M:%S %e/%m'
        }
      }
      let volumeSerie = {
        name: this.i18nService.get('volume') + ' (L)',
        data: [],
        yAxis: 1,
        tooltip: {
          valueSuffix: ' L',
          xDateFormat: '%H:%M:%S %e/%m',
        }
      }

      if(tankSeries.length > 0){
        tankSeries.forEach(tank => {
          tempSerie.data.push([tank.updated, tank.temperature]);
          waterSerie.data.push([tank.updated, tank.waterHeight]);
          volumeSerie.data.push([tank.updated, tank.productVolume]);
        });
      }
      series.push(tempSerie);
      series.push(waterSerie);
      series.push(volumeSerie);

    return series;
  }
}
